"use strict";
/* eslint-disable prettier/prettier */
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWS_REGION_MARKETS = void 0;
const aws_1 = require("../aws");
const country_code_1 = require("../country-code");
exports.AWS_REGION_MARKETS = {
    [aws_1.AwsRegions.APSE1]: [
        country_code_1.IsoCountryCode2Char.ID,
        country_code_1.IsoCountryCode2Char.JP,
        country_code_1.IsoCountryCode2Char.KR,
        country_code_1.IsoCountryCode2Char.MY,
        country_code_1.IsoCountryCode2Char.NZ,
        country_code_1.IsoCountryCode2Char.SG,
        country_code_1.IsoCountryCode2Char.TH,
        country_code_1.IsoCountryCode2Char.TW,
    ],
    [aws_1.AwsRegions.EUC1]: [
        country_code_1.IsoCountryCode2Char.AQ,
        country_code_1.IsoCountryCode2Char.AT,
        country_code_1.IsoCountryCode2Char.CH,
        country_code_1.IsoCountryCode2Char.CZ,
        country_code_1.IsoCountryCode2Char.DE,
        country_code_1.IsoCountryCode2Char.ES,
        country_code_1.IsoCountryCode2Char.FR,
        country_code_1.IsoCountryCode2Char.NL,
        country_code_1.IsoCountryCode2Char.PL,
        country_code_1.IsoCountryCode2Char.PT,
        country_code_1.IsoCountryCode2Char.RO,
    ],
    [aws_1.AwsRegions.USE1]: [
        country_code_1.IsoCountryCode2Char.AQ,
        country_code_1.IsoCountryCode2Char.CA,
        country_code_1.IsoCountryCode2Char.CH,
        country_code_1.IsoCountryCode2Char.GB,
        country_code_1.IsoCountryCode2Char.US,
        country_code_1.IsoCountryCode2Char.ZA,
    ],
};
//# sourceMappingURL=aws-region.js.map